import sanityClient from '@sanity/client';

export default sanityClient({
  projectId: 'ff7qiwem',  // A Sanity projekt ID-d (a képen látható)
  dataset: 'production',  // Dataset neve (alapértelmezett a "production")
  apiVersion: '2023-09-27', // Az API verzió dátuma, vagy a mai dátum
  useCdn: true, // Gyorsítótárazás engedélyezése a gyors lekérdezésekhez
  token: 'skelYW2C3q4g8fSUV8NwIaBk3aHFlsf3zFrjgoshQYLij6daIVdIilZOGgjgWY5mh0k11XWMrX7aNPjriRLtkFS6V4C0fRBKKYjcCKjPmmcKvUg1scuBZJx634vXgP3hMkrqbTsdgeb79Bvi4ceuqKmQP24jcNtbYwx5HFkUfUkqSbxLruoN', // A token, amit most generáltál
});
